import { Md5 } from "ts-md5";

import { Avatar, AvatarProps, HStack, Text } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";

const UserAvatar_User = graphql(`
  fragment UserAvatar_User on User {
    id
    username
    fullName
    avatarUrl
    deactivated
  }
`);

type UserAvatarProps = {
  avatarUrl?: string;
  displayName?: boolean;
  user?: FragmentType<typeof UserAvatar_User>;
};

export default function UserAvatar({
  user: propUser,
  avatarUrl,
  displayName = false,
  ...avatarProps
}: UserAvatarProps & AvatarProps) {
  const user = getFragmentData(UserAvatar_User, propUser);

  if (!user) return <Avatar height={8} loading="eager" width={8} {...avatarProps} />;

  const name = user.fullName || user.username;

  const avatar = (
    <Avatar
      ignoreFallback
      height={8}
      loading="eager"
      name={name ?? ""}
      src={
        avatarUrl ??
        user.avatarUrl ??
        (name && `https://www.gravatar.com/avatar/${Md5.hashStr(name.toLowerCase())}?d=retro`) ??
        ""
      }
      width={8}
      {...avatarProps}
    />
  );

  if (displayName)
    return (
      <HStack>
        {avatar}
        <Text>
          {name} {user.deactivated ? "(deactivated)" : ""}
        </Text>
      </HStack>
    );

  return avatar;
}
